
import NewsletterSubscribe from '../graphql/mutations/NewsletterSubscribe'

export default {
  inheritAttrs: false,
  props: {
    listId: {
      type: String,
      default: null
    },
    button: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: 'site.subscribe.button'
    }
  },
  computed: {
    mutation() {
      return NewsletterSubscribe
    },
    inputs() {
      return [
        {
          $type: 'input',
          $id: 'email',
          prop: 'email',
          $attrs: {
            span: 2,
          },
          $el: {
            type: 'email',
            label: 'Email',
            placeholder: 'email@example.com'
          },
          rules: [
            {
              required: true,
              message: this.$t('site.validations.required'),
              trigger: 'change'
            },
            {
              type: 'email',
              message: this.$t('site.validations.email'),
              trigger: 'blur'
            }
          ]
        }
      ]
    }
  }
}
